import { NgModule } from "@angular/core";
import { TranslationPipe } from "../../services";

@NgModule({
  imports: [],
  providers: [],
  declarations: [TranslationPipe],
  exports: [TranslationPipe],
  bootstrap: [],
  entryComponents: [],
  schemas: [],
})
export class TranslationModule {}
